import { ButtonHTMLAttributes, forwardRef, useImperativeHandle, useLayoutEffect, useRef, useState } from 'react';
import { ButtonRef } from '../models/IButtonRef';

export interface MyButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  proceed?: () => void;
  text: string;
  class: string;
  disabled?: boolean;
}

const ButtonCustom = forwardRef<ButtonRef, MyButtonProps>((props, ref) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isDisabled, setIsDisabled] = useState<boolean>();
  // Update isDisabled state when props.disabled changes
  useLayoutEffect(() => {
    if (props.disabled) {
      buttonRef.current?.setAttribute('disabled', 'true');
      setIsDisabled(true);
    } else {
      buttonRef.current?.removeAttribute('disabled');
      setIsDisabled(false);
    }
  }, [props.disabled]);

  // Define custom event handlers
  useImperativeHandle(ref, () => ({
    focus: () => {
      buttonRef.current?.focus();
    },
    disable: () => {
      buttonRef.current?.setAttribute('disabled', 'true');
      setIsDisabled(true);
    },
    enable: () => {
      setIsDisabled(false);
      buttonRef.current?.removeAttribute('disabled');
    },
    blur: () => {
      buttonRef.current?.blur();
    },
  }));

  return (
    <>
      <button type="button" ref={buttonRef} onClick={props?.proceed} disabled={isDisabled} className={props?.class}>
        {props?.text}
      </button>
    </>
  );
});

export default ButtonCustom;
